import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { DataTemplate } from '../../../utils/types/dataTemplate';

const renderEllipsisWithTooltip = (value: unknown) => {
  const text = value === null || value === undefined ? '' : String(value);
  const maxLength = 50;
  const truncatedText =
    text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

  return (
    <Tooltip title={text} placement="top-start">
      <Box
        sx={{
          width: '100%',
          display: 'block',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        }}
      >
        {truncatedText}
      </Box>
    </Tooltip>
  );
};

const template: DataTemplate[] = [
  {
    field: 'id',
    headerName: 'ID',
    minWidth: { md: 100, xs: '30vw' },
    flex: 1,
    type: 'id',
    filterable: false,
    sort: false,
  },
  {
    field: 'icon_url',
    headerName: '画像',
    minWidth: { md: 120, xs: '32vw' },
    flex: 1,
    type: 'img',
    filterable: false,
    sort: false,
  },
  {
    field: 'title',
    headerName: '案件表示名',
    filterName: '案件表示名',
    minWidth: { md: 180, xs: '38vw' },
    flex: 1.5,
    type: 'string',
    filterable: true,
    sort: false,
  },
  {
    field: 'title_internal',
    headerName: '案件名',
    filterName: '案件名',
    minWidth: { md: 180, xs: '38vw' },
    flex: 1.5,
    type: 'string',
    filterable: true,
    sort: false,
  },
  {
    field: 'requirements',
    headerName: '達成条件',
    minWidth: { md: 220, xs: '50vw' },
    flex: 2,
    type: 'custom',
    renderProps: value => renderEllipsisWithTooltip(value),
    filterable: false,
    sort: false,
  },
  {
    field: 'point',
    headerName: 'ポイント',
    minWidth: { md: 110, xs: '28vw' },
    flex: 1,
    type: 'string',
    filterable: false,
    sort: false,
  },
  {
    field: 'category',
    headerName: 'カテゴリ',
    minWidth: { md: 140, xs: '32vw' },
    flex: 1,
    type: 'string',
    filterable: false,
    sort: false,
  },
  {
    field: 'type',
    headerName: '種別ID',
    minWidth: { md: 140, xs: '32vw' },
    flex: 1,
    type: 'string',
    filterable: false,
    sort: false,
  },
  {
    field: 'clid',
    headerName: 'CLID',
    filterName: 'CLID',
    minWidth: { md: 140, xs: '32vw' },
    flex: 1,
    type: 'string',
    filterable: true,
    sort: false,
  },
  {
    field: 'sort',
    headerName: '順位',
    minWidth: { md: 100, xs: '26vw' },
    flex: 0.8,
    type: 'string',
    filterable: false,
    sort: false,
  },
  {
    field: 'deleted_at',
    headerName: '表示',
    minWidth: { md: 100, xs: '26vw' },
    flex: 0.8,
    type: 'custom',
    renderProps: value => (value ? 'OFF' : 'ON'),
    filterable: false,
    sort: false,
  },
  {
    field: 'bonus_type',
    headerName: 'ボーナスタイプ',
    minWidth: { md: 120, xs: '28vw' },
    flex: 0.8,
    type: 'custom',
    renderProps: value => (value === 1 ? 'ON' : 'OFF'),
    filterable: false,
    sort: false,
  },
  {
    field: 'bonus_point',
    headerName: 'ボーナスポイント',
    minWidth: { md: 120, xs: '30vw' },
    flex: 0.8,
    type: 'string',
    filterable: false,
    sort: false,
  },
  {
    field: 'stages',
    headerName: '対象者',
    minWidth: { md: 220, xs: '48vw' },
    flex: 1.5,
    type: 'custom',
    renderProps: value => renderEllipsisWithTooltip(value),
    filterable: false,
    sort: false,
  },
  {
    field: 'notes',
    headerName: '応募の仕方',
    minWidth: { md: 220, xs: '48vw' },
    flex: 1.5,
    type: 'custom',
    renderProps: value => renderEllipsisWithTooltip(value),
    filterable: false,
    sort: false,
  },
  {
    field: 'url',
    headerName: 'url',
    filterName: 'URL',
    minWidth: { md: 280, xs: '60vw' },
    flex: 2,
    type: 'string',
    filterable: true,
    sort: false,
  },
  {
    field: 'edit',
    headerName: '編集',
    minWidth: { md: 100, xs: '28vw' },
    flex: 0.7,
    type: 'Edit',
    filterable: false,
  },
];
export default template;

export type userData = Record<string, never>;
